<div class="container">
  <div class="patient-detail-card">
    <div class="row">
      <div class="col-md-6 patient-name">
        <p>{{ patientName }}</p>
      </div>
      <div class="col-md-6 patient-crid">
        <span class="research-id-text">CIBMTR Research ID (CRID) : </span>
        <span>{{ crid }}</span>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="col-md-12 observation-label">Collection</div>
    <div class="row collection-row" style="margin: 10px;" >
      <div class="col-md-3 resource-collection">
        <div class="col-md-12">
          <div class="resource-label">
            <a class="text-decoration-none"
              (click)="openConfirmationDialog('priority')"
              id="priority"
              [ngClass]="{ active: activeLabel == 'priority' }"
              >Priority Labs
            </a>

            @if (priorityState) {
              @if (priorityState === 'error') {
                <mat-icon
                  class="float-end"
                  color="warn"
                  >
                  warning
                </mat-icon>
              } @else {
                <b class="badge float-end" >{{
                  priorityState.total
                }}</b>
              }
            }
          </div>
          <br />
          <div class="resource-label">
            <a class="text-decoration-none"
              (click)="openConfirmationDialog('labs')"
              id="lab"
              [ngClass]="{ active: activeLabel == 'lab' }"
              >All Labs
            </a>

            @if (labsState) {
              @if (labsState === 'error') {
                <mat-icon
                  class="float-end"
                  color="warn"
                  >
                  warning
                </mat-icon>
              } @else {
                <b class="badge float-end">{{
                  labsState.total
                }}</b>
              }
            }
          </div>
          <br />
          @if (isR4) {
            <div>
              <div class="resource-label">
                <a class="text-decoration-none"
                  (click)="openConfirmationDialog('vitals')"
                  id="vitalsigns"
                  [ngClass]="{ active: activeLabel == 'vitalsigns' }"
                  >Vital Signs
                </a>
                @if (vitalState) {
                  @if (vitalState === 'error') {
                    <mat-icon
                      class="float-end"
                      color="warn"
                      >
                      warning
                    </mat-icon>
                  } @else {
                    <b class="badge float-end">{{
                      vitalState.total
                    }}</b>
                  }
                }
              </div>
              <br />
              <div class="resource-label">
                <a class="text-decoration-none"
                  (click)="openMedsConfirmationDialog()"
                  id="medications"
                  [ngClass]="{ active: activeLabel == 'medications' }"
                  >Medication Request
                </a>
                @if (medicationState) {
                  @if (medicationState === 'error') {
                    <mat-icon
                      class="float-end"
                      color="warn"
                      >
                      warning
                    </mat-icon>
                  } @else {
                    <b class="badge float-end">{{
                      medicationState.total
                    }}</b>
                  }
                }
              </div>
            </div>
          }

          <hr class="collection-divider">

          <!-- Date Range Picker -->
          <app-date-range-picker
            [isR4]="isR4"
            (dateRangeApplied)="onDateRangeApplied($event)"
            (dateRangeCleared)="onDateRangeCleared()">
          </app-date-range-picker>

        </div>
      </div>

      <div class="col-md-9 resource-box-shadow">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
